const navContainer = document.querySelector('.header__inline-menu');
const navBlock = document.querySelectorAll('.menu_hover');
const navDetails = document.querySelectorAll('.details_header');
const navList = document.querySelector('.header_megamenu_grid');
const navListContainer = document.querySelector('.header__inline-menu');

const navClose = function(){
  navDetails.forEach( d => d.removeAttribute('open',''));
}

navContainer.addEventListener('mouseover', function(e){
  const hover = e.target.closest('.menu_hover');
  if (!hover) return;
navBlock.forEach( n => n.classList.remove('visible'));
navClose();
hover.classList.add('visible');
  
if ( hover.classList.contains('visible') ){ 
document.querySelector(`#Details-HeaderMenu-${hover.dataset.hover}`).setAttribute('open','');
} else {
document.querySelector(`#Details-HeaderMenu-${hover.dataset.hover}`).removeAttribute('open','');
}
  
});

navList.addEventListener('mouseleave',function(){
  navClose();
});

navListContainer.addEventListener('mouseleave',function(){
  navClose();
});


